import React, {ReactElement} from 'react';
import BackArrow from '@components/system/MyIcons/BackArrow';
import {useTranslation} from 'react-i18next';
// styles
import './BackNavigationStyles.scss';
const BackNavigation = (props: any): ReactElement => {
  const {navigateTo} = props;
  const {t} = useTranslation();

  const goBack = (): void => {
    if (typeof navigateTo === 'function') {
      navigateTo();
    }
  };
  return (
    <div className="back-navigation-wrapper" onClick={(): void => goBack()}>
      <BackArrow />
      {t('PAYMENTS_LOGIN.CARD.BACK')}
    </div>
  );
};
export default BackNavigation;
